module.exports = __webpack_public_path__ + "static/media/plane-path.a9006d33.svg";